import { z } from "zod";

export const createConversationSchema = z.object({
	user_id: z.string(),
	group_id: z.string(),
});

export type CreateConversationPayload = z.infer<typeof createConversationSchema>;
